// extracted by mini-css-extract-plugin
export var recipeCard__container = "RecipeCard-module--recipeCard__container--90bff";
export var recipeCard__content = "RecipeCard-module--recipeCard__content--640f6";
export var recipeCard__content_text = "RecipeCard-module--recipeCard__content_text--5d835";